// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper-2T0Kw","wrapper_business":"wrapper_business-RMlxn","fareGroup":"fareGroup-CpWyH"};